/*

    (c) starshiptroopers.dev

 */
import {mapContext} from "@/context/global.js";

export class UIWorkspaceBounds {
    constructor(workspace, map, wsBoundsLayerGroup) {
        this.visible          = false;
        this.workspace              = workspace
        this.boundsLayerGroup       = wsBoundsLayerGroup
        this.map                    = map;
        //logging function
        this.elog = (typeof elog === "function") ? elog : function (severity, message) {
            if (typeof console[severity.toLowerCase()] === "function") {
                console[severity.toLowerCase()](message);
            }
        };

        this.boundsLayer = null
        this.boundsStyle = {
            stroke: true,
            weight: 1,
            opacity: 0.8,
            color: "orange",
            fillColor: "green",
            fillOpacity: 0.05
        };

        this.workspace.on("boundschanged", function () {
            this.updateBoundsVisibility()
        }.bind(this))
    }

    updateBoundsVisibility() {
        if (! this.boundsLayerGroup)
            return

        if (!this.workspace.map && this.boundsLayer) {
            this.boundsLayerGroup.removeLayer(this.boundsLayer)
            this.boundsLayer.remove()
            return
        }

        if (this.visible && this.workspace.isVisibleReal() && this.workspace.getBounds()) {
            if (! this.boundsLayer) {
                this._createBoundsLayer()
            } else {
                this.boundsLayer.setBounds(this.workspace.getBounds())
                if (! this.boundsLayer._map)
                    this.boundsLayer.addTo(this.map)
            }
        } else {
            if (this.boundsLayer)
                this.boundsLayer.remove()
        }
    }

    _createBoundsLayer() {
        this.boundsLayer = L.rectangle(this.workspace.getBounds(), this.boundsStyle)
        this.boundsLayer.setStyle({pmIgnore: true})
        this.boundsLayer.addTo(this.boundsLayerGroup);
        this.boundsLayer.bringToBack()

        mapContext.mapUI.enableRectangleResizeCapability(this.boundsLayer, this._boundsResized.bind(this))
        mapContext.mapUI.enableRectangleResizeInnerBlockLimiter(this.boundsLayer, function () {
            return this.workspace.layersCoveredBounds()
        }.bind(this))
    }

    _boundsResized() {
        // if for some reason new bounds is less than all layers covered bounds, fix them
        this.boundsLayer.setBounds(this.boundsLayer.getBounds().extend(this.workspace.layersCoveredBounds()))
        this._logdebug(`resized from ${this.workspace.bounds.toBBoxString()} to ${this.boundsLayer.getBounds().toBBoxString()}`)

        let features = mapContext.getFeaturesCoveredWithBounds(this.boundsLayer.getBounds())
        if (features.length > 0) {
            mapContext.mapUI.createFeaturesMoveToWorkspaceDialog(features, function () {
                mapContext.globalWorkspace.moveFeaturesToWorkspace(features, this.workspace)
            }.bind(this))
        }

        this.workspace.setBounds(this.boundsLayer.getBounds())
    }

    show() {
        if (this.map == null)
            return

        this.visible = true
        this.updateBoundsVisibility()
    }

    hide() {
        this.visible = false
        this.updateBoundsVisibility()
    }

    isVisible() {
        return this.visible;
    }

    _logdebug(msg) {
        if (this.workspace.debug)
            this.elog("DEBUG", `Workspace bounds ${this.workspace.id} ${msg}`)
    }
}
